import { Button, Card, Col, Form, Input, message, Row, Space, Typography, Tooltip } from "antd";
import { PlusOutlined, FileTextOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import _BankerService from "../../modules/BankerService";
import { COMMON_ERROR_MSG, SUBMISSION_FAILED } from "../../constants/constants";
import _commonService from "../../modules/commonService";

const { Title, Text } = Typography;

const SummaryTermsProjectedInterest = ({ ApplicationObjId }) => {
    const [tdsrForm] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const BankerId = localStorage.getItem("BankerId");
    const [currentId, setcurrentId] = useState();
    const [summaryTermsData, setSummaryTermsData] = useState({
        LoanAmount: 0,
        IntrestRate: 0,
        AdvanceRate: 0,
        DebtServiceProfarma: 0,
    });
    useEffect(() => {
        getBankerMetricsDataByBankerID();
    }, [])

    const getBankerMetricsDataByBankerID = async () => {
        try {
            setLoading(true);

            const res = await _BankerService.getRiskFreeLoanByApplicantId(ApplicationObjId);
            console.log(res, "res")
            if (res.data.IsSuccess) {
                setSummaryTermsData({
                    TotalProgramSize: res.data.Obj.TotalProgramSize ?? 0,
                    IntrestRate: res.data.Obj.IntrestRate ?? 0,
                    AdvanceRate: res.data.Obj.AdvanceRate ?? 0,
                    DebtServiceProfarma: res.data.Obj.DebtServiceProfarma ?? 0,
                    RequestedLoanAmount: res.data.Obj.RequestedLoanAmount ?? 0,
                    ProjectedAnnualInterestExpense: res.data.Obj.ProjectedAnnualInterestExpense ?? 0,


                });
                setcurrentId(res.data.Obj.Id)

                setLoading(false);
            } else {
                setLoading(false);
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (error) {
            setLoading(false);
            console.log(error);
        } finally {
            setLoading(false);
        }
    };
    return (
        <>
            <Card className="card-section summary-terms-projected-interest-card"
                title={
                    <div className="chartbox-title">
                        <FileTextOutlined className="chartbox-title-icon" />
                        Credit Facility Details
                    </div>
                }>
                    <div className="">
                <Row gutter={[16, 16]}>
                    <Col span={6}>
                        <Text type="secondary">Requested Loan Amount:</Text>
                        <div className="summary-value">
                            {summaryTermsData && summaryTermsData.RequestedLoanAmount ? `$ ${_commonService.formatNumberWithCommas(summaryTermsData.RequestedLoanAmount)}` : "N/A"}
                        </div>
                    </Col>

                    <Col span={6}>
                        <Text type="secondary">Advance Rate:</Text>
                        <div className="summary-value">
                           {summaryTermsData?.AdvanceRate ? `${summaryTermsData.AdvanceRate} %` : "N/A"}
                        </div>
                    </Col>

                    <Col span={6}>
                        <Text type="secondary">Interest Rate:</Text>
                        <div className="summary-value">
                            {summaryTermsData?.IntrestRate ? `${summaryTermsData.IntrestRate} %` : "N/A"}
                        </div>
                    </Col>

                    <Col span={6}>
                        <Text type="secondary">Projected Interest Expense:</Text>
                        <div className="summary-value">
                            {summaryTermsData && summaryTermsData.ProjectedAnnualInterestExpense ? `$ ${_commonService.formatNumberWithCommas(summaryTermsData.ProjectedAnnualInterestExpense)}` : "N/A"}
                        </div>
                    </Col>
                </Row>
                </div>
            </Card>
        </>
    )
}
export default SummaryTermsProjectedInterest;